import { isProductionHost } from "@/config/domains";

function configuredAppHost(): string | null {
  const url = process.env.NEXT_PUBLIC_APP_URL?.trim();
  if (!url) return null;
  try {
    return new URL(url).hostname;
  } catch {
    return null;
  }
}

export function isSentryEnabled(): boolean {
  if (!process.env.NEXT_PUBLIC_SENTRY_DSN) return false;
  if (isProductionHost(configuredAppHost())) return true;

  return process.env.SENTRY_ENABLE_LOCAL === "1" || process.env.NEXT_PUBLIC_SENTRY_ENABLE_LOCAL === "1";
}

export function sentryTracesSampleRate(): number {
  return process.env.NODE_ENV === "production" ? 0.2 : 1.0;
}
